export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const { clear } = useAuth()

    // Tokens are no longer persisted; drop any an older build left behind
    localStorage.removeItem('auth_token')
    localStorage.removeItem('refresh_token')

    // Cross-tab synchronization: logout in another tab sets auth_logout
    window.addEventListener('storage', async (e) => {
      if (e.key === 'auth_logout' && e.newValue) {
        await clear()
        await navigateTo('/login')
      }
    })
  }
})
